import { ActionIcon, BadgeProps, Flex } from '@mantine/core'
import { StatusBadge } from 'components/common/StatusBadge'
import { TbX } from 'react-icons/tb'
import { useRemoveTagMutation } from './hooks/useRemoveTagMutation'

type TagBadgeProps = BadgeProps & {
  value: string
  label?: string
  deviceId: string
}

export const TagBadge = ({
  value,
  label,
  color = 'brand',
  deviceId,
}: TagBadgeProps) => {
  const removeMutation = useRemoveTagMutation({ deviceId })

  return (
    <StatusBadge color={color} mr={'xs'} pr={2}>
      <Flex>
        {label ?? value}
        <ActionIcon
          onClick={() => removeMutation.mutate(value)}
          size="xs"
          radius="xl"
          variant="transparent"
          ml="xs"
        >
          <TbX size={10} />
        </ActionIcon>
      </Flex>
    </StatusBadge>
  )
}
